 /**
     * Shooping Cart
     */
    /// subscribe box
    $('.cart--tabs #subscribeBox').on("click", function () {
        $(this).find('.cart__checkbox').toggleClass('checked');
        $('.cart--tabs .cta').toggleClass('disabled');
    })

    //// activate subscribe prices    
    let cartModeCTA = $('.cart--tabs .cart__mode-cta'),
        subscribeMode = $('.cart--tabs #subscribeMode'),
        disclaimerBox = $('.cart--tabs #disclaimerBox');

    $(cartModeCTA).on('click', function () {
        let thisBtn = $(this);
            
        cartModeCTA.removeClass('active');
        thisBtn.addClass('active');
        
        if (thisBtn.hasClass('subscribe')) {
            $('.cart--tabs').attr('data-subscribe', 'subscribe');
            $('#subscribeWrap').removeClass('hide').addClass('show');
            $('.cart .cta').addClass('disabled');
        } else {
            resetSubscribe();
        }
        $('.cart__product.active').trigger("click");
    });

    $('.purchaseMode__input').on('click', function (check) {
        // console.log($(this).is(":checked"));
        
        let checkboxType;

        if ($('.cart--tabs').attr('data-subscribe') === 'unsubscribe') {
            checkboxType = true;

            subscribeOn();
            
        } else {
            checkboxType = false;
            
            subscribeOff();
        }

        this.setAttribute('checked', checkboxType);

        $('.cart__product.active').trigger("click");
    });

    function subscribeOn() {
        $('.cart--tabs').attr('data-subscribe', 'subscribe');
        subscribeMode.attr('data-subscribe', 'subscribe');
        disclaimerBox.addClass('subscribe-box__disclaimer--open');
    }

    function subscribeOff() {
        $('.cart--tabs').attr('data-subscribe', 'unsubscribe')
        subscribeMode.attr('data-subscribe', 'unsubscribe');

        // on touch screens
        if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.removeClass('subscribe-box__disclaimer--open');
        }
    }

    function resetSubscribe() {
        $('.cart--tabs').attr('data-subscribe', 'unsubscribe')
        $('#subscribeWrap').removeClass('show').addClass('hide');
        $('.cart .cta').removeClass('disabled');
        $('#subscribeBox .cart__checkbox').removeClass('checked');
    }

    ////set prices
    function setLinks() {
        let thisProduct = $(this);
        let link;
        const subscribe = $('#choosePrices').attr('data-subscribe');
        const subscribeCheckbox = $('.cart--tabs').attr('data-subscribe');

        if (subscribeCheckbox === 'subscribe') {
            link = 'data-subscribe-link';
        } else {
            link = 'data-link';
        }
        let param = $('.cta').attr('data-param');

        // console.log(thisProduct.attr(link));
        // console.log(thisProduct.attr(link).includes('?'));
        // console.log(param);

        // if(thisProduct.attr(link).includes('?') == false) {
        //     param = '?' + param
        // } else {
        //     param = '&' + param
        // }

        $('.cart .cta').attr('href', thisProduct.attr(link) + param);
    }

    function normalActiveProduct() {
        let thisProduct = $(this);
        let amount, link, ship;
        const units = thisProduct.attr('data-units');
        const subscribe = $('#choosePrices').attr('data-subscribe');
        const subscribeCheckbox = $('.cart--tabs').attr('data-subscribe');
        const badge = 'data-badge';

        if (subscribeCheckbox === 'subscribe') {
            amount = 'data-subscribe-price';
            link = 'data-subscribe-link';
            ship = 'data-subscribe-shipping';

            $('.cart__details').addClass('cart__details--subscribe');

            // if (units === '1') {
            //     $('#badgeText').html('BEST<br> SELLER');
            // } else {
            //     $('#badgeText').html('');
            // }

        } else {
            amount = 'data-price';
            link = 'data-link';
            ship = 'data-shipping';

            $('.cart__details').removeClass('cart__details--subscribe');

            // if (units === '3') {
            //     $('#badgeText').html('BEST<br> SELLER');
            // } else {
            //     $('#badgeText').html('');
            // }
        }

        if (units === '3' || units === '6') {
            $('#badgeText').html(thisProduct.attr(badge));
        }

        $('.cart__product').removeClass('active');
        thisProduct.addClass('active');

        $("#orderNow").removeClass(function (index, className) {
            return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
        }).addClass('cart--unit' + units);

        $('.cart__unit-value').html('$' + parseFloat(
            (thisProduct.attr(amount)) / (thisProduct.attr('data-units'))
        ).toFixed(2));
        $('.cart__current-value').html('$' + thisProduct.attr(amount));
        $('.cart__retail-value').html('$' + thisProduct.attr('data-retail'));
        $('.cart__shipping-value').html(thisProduct.attr(ship));
    };

    $('.cart--tabs .cart__product').on('click', normalActiveProduct);
    $('.cart--tabs .cart__product').on('click', setLinks);
    $('.cart--tabs .cart__product.active').trigger("click");
